export default __webpack_public_path__ + "fonts/NEXT-Book/NEXT-Book-Regular.woff2";